import React from 'react'
import Assignments from './RightNavComponents/Assignments'
import Contacts from './RightNavComponents/Contacts'
import { Wrapper, InnerWrapper } from './RightNavStyles'

const RightNav = ({ rightNavbarMinified, setRightNavbarMinified }) => {
  // const [rightNavbarMinified, setRightNavbarMinified] = React.useState(true)

  return (
    <Wrapper width={rightNavbarMinified ? '111px' : '271px'}>
      <InnerWrapper>
        <Assignments
          rightNavbarMinified={rightNavbarMinified}
          setRightNavbarMinified={setRightNavbarMinified}
        />
        {/* <Contacts
          rightNavbarMinified={rightNavbarMinified}
          setRightNavbarMinified={setRightNavbarMinified}
        /> */}
      </InnerWrapper>
    </Wrapper>
  )
}

export default RightNav
